'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvPlayCircleOutline = function AvPlayCircleOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
  );
};
AvPlayCircleOutline = (0, _pure2.default)(AvPlayCircleOutline);
AvPlayCircleOutline.displayName = 'AvPlayCircleOutline';
AvPlayCircleOutline.muiName = 'SvgIcon';

exports.default = AvPlayCircleOutline;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/av/play-circle-outline.js
// module id = 2720
// module chunks = 0